import React from 'react';
import { PaymentForm } from '../components/PaymentForm';
export function PaymentRequests() {
  return <div data-id="element-9763">
      <PaymentForm data-id="element-9764" />
    </div>;
}